// extracted by mini-css-extract-plugin
export default {"titleWrapper":"index_titleWrapper__igoBv","section":"index_section__fCI2h","bold":"index_bold__M2JMm"};